import { useTranslation } from 'react-i18next';
import { useCreateStandingOrderMutation } from '../../../api/standing-orders';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { MainLayout } from '../../Layout/MainLayout';
import { Grid } from '@razz-team/ui-web';
import { StandingOrderStepper, StandingOrderSteps } from './StandingOrderStepper';
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { StandingOrderOriginStep } from './StandingOrderOriginStep';
import { useIdempotencyKey } from '../../../hooks/useIdempotencyKey';

export function CreateStandingOrderPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const idempotencyKey = useIdempotencyKey();
  const mutation = useCreateStandingOrderMutation({ idempotencyKey });

  useEffect(() => {
    if (mutation.isSuccess) {
      navigate({
        to: '/account/standing-orders/$orderId/$step',
        params: { orderId: mutation.data.id, step: 'destinations' },
      });
    }
  }, [mutation, navigate]);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Add standing order')}
          parent={{
            title: t('Standing orders'),
            to: '/account/standing-orders',
          }}
        />
      }
      compact
    >
      <Grid size={12}>
        <StandingOrderStepper activeStep={StandingOrderSteps.origin} />
      </Grid>
      <StandingOrderOriginStep mutation={mutation} />
    </MainLayout>
  );
}
